"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const SocialFacebook = createSVGIcon(
  <path
    d="M13.714 6.857c0-1.714.857-1.714 1.714-1.714h1.029A1.286 1.286 0 0 0 17.76 3.84V2.229A1.304 1.304 0 0 0 16.44.926L14.005.89a4.903 4.903 0 0 0-5.057 5.486v2.486H7.594a1.303 1.303 0 0 0-1.303 1.303v1.611a1.303 1.303 0 0 0 1.303 1.303h1.354v9.206a.857.857 0 0 0 .857.857h3.103a.857.857 0 0 0 .806-.857V13.08h1.508a1.303 1.303 0 0 0 1.303-1.303v-1.611a1.303 1.303 0 0 0-1.303-1.303h-1.508z"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "SocialFacebook",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      defaultMessage: "Facebook",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
  })
);
